export const getPlatformUrl = (windowLocation: Location, gameToken: string) => {
    const urlParams = new URLSearchParams(windowLocation.search);
    const tg = urlParams.get('tg');
    const lang = urlParams.get('lang') || '';
    const has_source_tg = windowLocation.search.includes('source_tg');
    const has_source_wf = windowLocation.search.includes('source_wf');

    const platformUrl = new URL(windowLocation.href);

    platformUrl.pathname = '/platform';
    platformUrl.searchParams.set('game_token', gameToken);

    if (lang) {
        platformUrl.searchParams.set('lang', lang);
    }
    if (has_source_tg) {
        platformUrl.searchParams.set('source_tg', urlParams.get('source_tg') || 'true');
    }
    if (has_source_wf) {
        platformUrl.searchParams.set('source_wf', urlParams.get('source_wf') || 'true');
    }
    if (tg) {
        platformUrl.searchParams.set('tg', tg);
    }

    return platformUrl.toString();
};
